import { flushSync } from "react-dom";
import { TOOL_PREP_ENTRY, toolPrepWorkspacePath } from "../../utils/editorEntrySession";

/**
 * Prep session for dashboard/tools in-page overlay (no route change).
 * Upload happens inside the prep Original card.
 * @returns {boolean} true when the tool key is ready to open
 */
export function prepareDashboardToolPrep({
  toolPrep,
  setNormalEntry,
  clearImage,
  writeToolPrepSession,
  clearEditorSession,
  entryMode = TOOL_PREP_ENTRY.DASHBOARD,
  /** When false, keep the current ImageContext source (e.g. after picker). */
  clearSource = true,
} = {}) {
  if (!toolPrep) return false;
  flushSync(() => {
    clearEditorSession?.();
    setNormalEntry?.();
    if (clearSource) clearImage?.();
  });
  writeToolPrepSession?.({
    toolPrep,
    entryMode,
  });
  return true;
}

/**
 * Deep-link / legacy: prepare session then navigate to /tools/:toolKey.
 * Prefer prepareDashboardToolPrep + in-page overlay on Dashboard/Tools.
 */
export function navigateToToolPrep(
  navigate,
  {
    toolPrep,
    setNormalEntry,
    clearImage,
    writeToolPrepSession,
    clearEditorSession,
    entryMode = TOOL_PREP_ENTRY.DASHBOARD,
  }
) {
  if (!toolPrep || !navigate) return;
  prepareDashboardToolPrep({
    toolPrep,
    setNormalEntry,
    clearImage,
    writeToolPrepSession,
    clearEditorSession,
    entryMode,
  });
  navigate(toolPrepWorkspacePath(toolPrep), {
    state: {
      toolPrepEntryMode: entryMode,
      openToolPrep: toolPrep,
    },
  });
}
